import {
  type schemaType,
  type returnType,
} from '~~/shared/api/rurality/v3/outings/outings/list/schema'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/outings/outings/list'

export const serverFetch = (): Promise<returnType> =>
  serverFetchWrapper<undefined, schemaType>(endpoint)

export const browserFetch = (): Promise<returnType> =>
  browserFetchWrapper<undefined, schemaType>(endpoint)
